"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.logging = exports.Logger = exports.LogManager = void 0;
const events_1 = require("events");
class LogManager extends events_1.EventEmitter {
    constructor() {
        super(...arguments);
        this.options = {
            minLevels: {
                '': 'warn',
            },
        };
        // Prevent the console logger from being added twice
        this.consoleLoggerRegistered = false;
    }
    configure(options) {
        this.options = Object.assign({}, this.options, options);
        return this;
    }
    getLogger(module) {
        let minLevel = 'none';
        let match = '';
        for (const key in this.options.minLevels) {
            if (module.startsWith(key) && key.length >= match.length) {
                minLevel = this.options.minLevels[key];
                match = key;
            }
        }
        return new Logger(this, module, minLevel);
    }
    onLogEntry(listener) {
        this.on('log', listener);
        return this;
    }
    registerConsoleLogger() {
        if (this.consoleLoggerRegistered)
            return this;
        this.onLogEntry((logEntry) => {
            const msg = `[${logEntry.module}] ${logEntry.message}`;
            switch (logEntry.level) {
                case 'trace':
                    console.trace(msg);
                    break;
                case 'debug':
                    console.debug(msg);
                    break;
                case 'info':
                    console.info(msg);
                    break;
                case 'warn':
                    console.warn(msg);
                    break;
                case 'error':
                    console.error(msg);
                    break;
                default:
                    console.log(`{${logEntry.level}} ${msg}`);
            }
        });
        this.consoleLoggerRegistered = true;
        return this;
    }
}
exports.LogManager = LogManager;
// Logger inspired in https://adrianhall.github.io/cloud/2019/06/30/building-an-efficient-logger-in-typescript/
class Logger {
    constructor(logManager, module, minLevel) {
        this.levels = {
            trace: 1,
            debug: 2,
            info: 3,
            warn: 4,
            error: 5,
        };
        this.logManager = logManager;
        this.module = module;
        this.minLevel = this.levelToInt(minLevel);
    }
    /**
     * Converts a string level (trace/debug/info/warn/error) into a number
     *
     * @param minLevel
     */
    levelToInt(minLevel) {
        if (minLevel.toLowerCase() in this.levels)
            return this.levels[minLevel.toLowerCase()];
        else
            return 99;
    }
    /**
     * Central logging method.
     * @param logLevel
     * @param message
     */
    log(logLevel, message) {
        const level = this.levelToInt(logLevel);
        if (level < this.minLevel)
            return;
        const logEntry = {
            level: logLevel,
            module: this.module,
            message,
        };
        // Obtain the line/file through a thoroughly hacky method
        // This creates a new stack trace and pulls the caller from it.  If the caller
        // if .trace()
        const error = new Error('');
        if (error.stack) {
            const cla = error.stack.split('\n');
            let idx = 1;
            while (idx < cla.length && cla[idx].includes('at Logger.Object.'))
                idx++;
            if (idx < cla.length) {
                logEntry.location = cla[idx].slice(cla[idx].indexOf('at ') + 3, cla[idx].length);
            }
        }
        this.logManager.emit('log', logEntry);
    }
    trace(message) {
        this.log('trace', message);
    }
    debug(message) {
        this.log('debug', message);
    }
    info(message) {
        this.log('info', message);
    }
    warn(message) {
        this.log('warn', message);
    }
    error(message) {
        this.log('error', message);
    }
}
exports.Logger = Logger;
exports.logging = new LogManager();
//# sourceMappingURL=js-logger.js.map